import { SideResponse } from "../../codegen-api";
import { ITableColumn } from "../../interfaces/Table/TableColumn";
import MarketCell from "../PortfolioSettings/Table/MarketCell";
import { renderBuySell, titleFor } from "./helpers";
import { ColumnContext, WithDecorations } from "./types";

export function buildMarketColumn<
  T extends WithDecorations<{ instrument_name?: string; leverage?: string | number }>
>({
  t,
  tooltips,
}: Pick<ColumnContext, "t" | "tooltips">): ITableColumn<T> {
  return {
    title: titleFor(t, "market"),
    accessor: "instrument_name",
    tooltip: tooltips("market"),
    Cell: ({ row }) => {
      // Only render leverage when the API actually provides a valid value.
      // `MarketCell` hides leverage on a falsy value, so pass `0` (not a
      // manufactured `1`) when it's absent — e.g. trade/order history rows,
      // which carry no leverage field.
      const lev = Number(row.original.leverage);
      return (
        <MarketCell
          instrumentName={row.original.instrument_name}
          leverage={Number.isFinite(lev) && lev > 0 ? lev : 0}
        />
      );
    },
  };
}

export function buildSideColumn<T extends { side?: SideResponse | string }>({
  t,
  tooltips,
}: Pick<ColumnContext, "t" | "tooltips">): ITableColumn<T> {
  return {
    title: titleFor(t, "side"),
    accessor: "side",
    tooltip: tooltips("side"),
    Cell: ({ value }) => renderBuySell(value as SideResponse, t),
  };
}
